<template>
  <div class="container-fluid no-padding-sides">
    <div class="row">
      <div class="col">
        <!-- Images part -->
        <div v-if="images && images.length" class="card card-mediatype shadow">
          <div class="card-body card-body-mediatype">
            <h5 class="card-title card-title-mediatype text-center">Images</h5>
            <div class="container-fluid no-padding-sides container-media">
              <div class="row justify-content-center row-media">
                <div class="col-12 col-sm-10 col-md-6 col-xl-4" v-for="image in images" :key="image.id">
                  <div class="card shadow-sm card-media" :class="image.isActive ? 'active' : 'not-active'" v-on:click="onCardMediaClicked(image)">
                    <img class="card-img-top img-fluid" :src="image.src" :alt="image.alt" />
                    <div class="card-body p-auto card-body-media">
                      <h5 class="card-title text-center my-auto card-title-media">{{ image.alt }}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <!-- Videos part -->
        <div v-if="videos && videos.length" class="card card-mediatype shadow">
          <div class="card-body card-body-mediatype">
            <h5 class="card-title card-title-mediatype text-center">Vidéos</h5>
            <div class="container-fluid no-padding-sides container-media">
              <div class="row justify-content-center row-media">
                <div class="col-12 col-sm-10 col-md-6 col-xl-4" v-for="video in videos" :key="video.id">
                  <div class="card shadow-sm card-media" :class="video.isActive ? 'active' : 'not-active'" v-on:click="onCardMediaClicked(video)">
                    <img class="card-img-top img-fluid" :src="video.src" :alt="video.alt" />
                    <div class="card-body p-auto card-body-media">
                      <h5 class="card-title text-center my-auto card-title-media">{{ video.alt }}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <!-- Urls part -->
        <div v-if="urls && urls.length" class="card card-mediatype shadow">
          <div class="card-body card-body-mediatype">
            <h5 class="card-title card-title-mediatype text-center">Urls</h5>
            <div class="container-fluid no-padding-sides container-media">
              <div class="row justify-content-center row-media">
                <div class="col-12 col-sm-10 col-md-6 col-xl-4" v-for="url in urls" :key="url.id">
                  <div class="card shadow-sm card-media" :class="url.isActive ? 'active' : 'not-active'" v-on:click="onCardMediaClicked(url)">
                    <img class="card-img-top img-fluid" :src="url.src" :alt="url.alt" />
                    <div class="card-body p-auto card-body-media">
                      <h5 class="card-title text-center my-auto card-title-media">{{ url.alt }}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <!-- Others part -->
        <div v-if="others && others.length" class="card card-mediatype shadow">
          <div class="card-body card-body-mediatype">
            <h5 class="card-title card-title-mediatype text-center">Autres</h5>
            <div class="container-fluid no-padding-sides container-media">
              <div class="row justify-content-center row-media">
                <div class="col-12 col-sm-10 col-md-6 col-xl-4" v-for="other in others" :key="other.id">
                  <div class="card shadow-sm card-media" :class="other.isActive ? 'active' : 'not-active'" v-on:click="onCardMediaClicked(other)">
                    <img class="card-img-top img-fluid" :src="other.src" :alt="other.alt" />
                    <div class="card-body p-auto card-body-media">
                      <h5 class="card-title text-center my-auto card-title-media">{{ other.alt }}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MediaType } from "@/models/enums";

export default {
  name: "select-media-component",

  props: {
    _medias: [],
    _selectedMedias: [],
  },

  data() {
    return {
      images: [],
      videos: [],
      others: [],
      urls: [],
      globalTemIndex: 0,
    };
  },

  async mounted() {
    // Complete init of component, called by mounted and by external event
    this.completeInit();
  },

  methods: {
    // Complete init of component, called by mounted and by external event
    completeInit() {
      // Initiate all media types
      this.initAllMedias();
      // Add active css class on selected medias
      this.activateSelectedMedias();
      // Initiate all media types (calling it twice there to sort it after activating class)
      this.initAllMedias();
    },
    // Add active css class on selected medias
    activateSelectedMedias() {
      // remove active class on each
      for (let i = 0; i < this._medias.length; i++) {
        this._medias[i].isActive = false;
      }

      // Apply active class
      if (this._selectedMedias && this._selectedMedias.length) {
        this._selectedMedias.forEach((refSelectedMedia) => {
          let indexMedia = this._medias.findIndex((media) => media.id === refSelectedMedia.id);
          this._medias[indexMedia].isActive = true;
        });
      }
    },
    // Initiate the images from medias
    initImages() {
      this.images = this._medias.filter((media) => media.mediaType == MediaType.IMAGE);
      this.images.map((media) => {
        if (media.isActive && media.tempIndex == null) media.tempIndex = this.globalTemIndex++;
        return media;
      });
      this.images = _.orderBy(this.images, ["isActive", "tempIndex"], ["desc", "asc"]);
    },
    // Initiate the videos from medias
    initVideos() {
      this.videos = this._medias.filter((media) => media.mediaType == MediaType.VIDEO);
      this.videos.map((media) => {
        if (media.isActive && media.tempIndex == null) media.tempIndex = this.globalTemIndex++;
        return media;
      });
      this.videos = _.orderBy(this.videos, ["isActive", "tempIndex"], ["desc", "asc"]);
    },
    // Initiate the urls from medias
    initUrls() {
      this.urls = this._medias.filter((media) => media.mediaType == MediaType.URL);
      this.urls.map((media) => {
        if (media.isActive && media.tempIndex == null) media.tempIndex = this.globalTemIndex++;
        return media;
      });
      this.urls = _.orderBy(this.urls, ["isActive", "tempIndex"], ["desc", "asc"]);
    },
    // Initiate the others from medias
    initOthers() {
      this.others = this._medias.filter((media) => media.mediaType == MediaType.OTHER);
      this.others.map((media) => {
        if (media.isActive && media.tempIndex == null) media.tempIndex = this.globalTemIndex++;
        return media;
      });
      this.others = _.orderBy(this.others, ["isActive", "tempIndex"], ["desc", "asc"]);
    },
    // Event on media card clicked
    onCardMediaClicked(mediaParam) {
      let indexMedia = this._medias.findIndex((media) => media.id === mediaParam.id);

      if (this._medias[indexMedia]) {
        if (this._medias[indexMedia].isActive) {
          this._medias[indexMedia].isActive = false;
          this._medias[indexMedia].tempIndex = null;
        } else {
          this._medias[indexMedia].isActive = true;
          this._medias[indexMedia].tempIndex = this.globalTemIndex++;
        }
      }

      // Initiate all media types
      this.initAllMedias();

      // Send event to parent
      this.$emit("onMediasSelected", this.getCurrentlySelectedMedias());
    },
    // Initiate all media types
    initAllMedias() {
      // Initiate the images from medias
      this.initImages();
      // Initiate the videos from medias
      this.initVideos();
      // Initiate the urls from medias
      this.initUrls();
      // Initiate the others from medias
      this.initOthers();
    },
    // return currently selected medias
    getCurrentlySelectedMedias() {
      return this._medias.filter((media) => media.isActive);
    },
  },
};
</script>

<style lang="scss" scoped>
.card-mediatype {
  padding-bottom: 1vh;
}
.card-body-mediatype {
  padding-top: 0;
  padding-bottom: 0;
  padding-right: 1vh;
  padding-left: 1vh;
}
.card-title-mediatype {
  font-weight: 800 !important;
}
.container-media {
  display: flex;
}
.row-media {
  width: 100%;
  height: 100%;
}
.card-media {
  height: 100%;
  cursor: pointer;
}
.card-body-media {
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 0.5vh;
}
.card-title-media {
  display: flex;
  align-items: center;
  overflow: hidden;
}
.active {
  border: 1px solid #0071c5;
  background-color: #0071c5;
  color: white;
  //   box-shadow: 0 .125rem .25rem rgba(0, 112, 197, 0.412) !important;
}
</style>
